import { BygrModule } from './../types';
import { BygrResidentialUnit } from '@/types';
import { request } from '@/utils/ajax';

export function getResidentialUnit(residentialUnitId: number): Promise<BygrResidentialUnit> {
    return request(`api/residentialUnit/${residentialUnitId}`).then((x) => x.json());
}

export function setModuleForResidentialUnits(residentialUnitIds: number[], module: BygrModule) {
    return request(`api/residentialUnit/module`, {
        method: 'POST',
        body: { residentialUnitIds, module },
        json: true,
    });
}